export default "__VITE_ASSET__CJ4$VuTh__"